/**
 * 温度帯（部門別）選定済商品数一覧情報を管理するクラス
 *
 * @export KYMW2000Model
 * @class KYMW2000Model
 */
export class TempSelectedSummary {
  constructor(
    public SelectedNumList: {
      ClassCode: string,
      ClassName: string,
      ClassGoodsCount: number,
      FreezedGoodsCount: number,
      RefrigeratedGoodsCount: number,
      RoomTempGoodsCount: number,
      VegetableGoodsCount: number,
      BreadGoodsCount: number,
      OtherStockedGoodsCount: number,
    }[],
    public SelectedTotalNum: {
      ClassGoodsCount: number,
      FreezedGoodsCount: number,
      RefrigeratedGoodsCount: number,
      RoomTempGoodsCount: number,
      VegetableGoodsCount: number,
      BreadGoodsCount: number,
      OtherStockedGoodsCount: number,
    },
  ) {}
}